module.exports = __webpack_public_path__ + "static/media/nbfc-award-02-12-22.1ca3249d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbfc-award-02-12-22.webp
// module id = 126
// module chunks = 0